<template>
  <div>
    <vs-prompt
      title="Add venue to REKOM POS"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      accept-text="Add"
      :is-valid="validForm"
      class=""
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Venue</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-select
                class="w-full"
                autocomplete
                label="Search for venue..."
                v-model="newVenueSelect"
              >
                <vs-select-item
                  :key="index"
                  :value="item"
                  :text="item.name"
                  v-for="(item, index) in globalVenues"
                />
              </vs-select>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      newVenueSelect: null,
      prompt: false,
    };
  },
  computed: {
    ...mapGetters({
      globalVenues: "venues/globalVenues",
    }),
    validForm() {
      return this.newVenueSelect !== null;
    },
  },
  methods: {
    show() {
      this.newVenueSelect = null;
      this.prompt = true;
    },
    async accept() {
      this.$vs.loading();

      await this.$store.dispatch(
        "pos/venues/createVenue",
        this.newVenueSelect.venueId
      );

      this.$vs.notify({
        color: "success",
        title: `Venue added`,
        text: "Venue added",
      });
      this.$vs.loading.close();
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
